module.exports = __webpack_public_path__ + "img/manage-product-4.37330320.jpg";